/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { Layout, Button, Form } from 'antd';
import SearchBar from '../../components/Shared/searchbar/SearchBar';
import { PlusOutlined } from '@ant-design/icons';
import ListCard from './components/ListCard';
import { useTranslation } from 'react-i18next';
import UserService from '../../services/UserService';
import ModalDelete from '../../components/Shared/modal/delete';
import ModalFail from '../../components/Shared/modal/fail';
import ModalDataFlow from './components/ModalDataFlow';
import moment from 'moment';
import useNotify from '../../context/Notification/useNotify';
import { STATUS_ID } from './STATUS_ID';
import ModalConfirm from '../../components/Shared/modal/confirm';
import DataFlowService from '../../services/DataFlow.service';
import usePermission from '../../hooks/usePermission';

export default function DataFlowList() {
    // Role
    const role = UserService.role()?.toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    const [form] = Form.useForm();

    const notify = useNotify();
    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 10,
        total: 0,
    });
    const [cardData, setCardData] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [businessProcess, setBusinessProcess] = useState('');
    const [searchValue, setSearchValue] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [statusType, setStatusType] = useState([]);
    const [openFail, setOpenFail] = useState(false);
    const [msg, setMsg] = useState('');
    const initialStatus = [
        STATUS_ID.REVIEWED, //Reviewed
        STATUS_ID.DRAFT, //Draft
        STATUS_ID.REVISE, //Revise
        STATUS_ID.WAITING_FOR_REVIEW, //Waiting for Review
    ];
    const [openConfirm, setOpenConfirm] = useState(false);
    const [loading, setLoading] = useState(true);
    const getDepartment = async () => {
        try {
            let lang = i18n.language;
            const params = {
                s: lang === 'en' ? 'nameEn' : 'nameTh',
            };
            const { data } = await DataFlowService.getDepartmentList(params);
            if (data?.resultData) {
                let option = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.departmentId,
                    });
                });
                setDepartmentList(option);
                if (!admin) {
                    form.setFieldsValue({ departmentId: option[0].id });
                    searchDataFlowList(
                        { departmentId: option[0].id },
                        currentPage
                    );
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getStatus = async () => {
        try {
            let lang = i18n.language;
            const { data } = await DataFlowService.getStatus({
                type: 'data-flow',
            });
            if (data?.resultData) {
                let option = [];
                let initial = [];
                data?.resultData?.forEach((element) => {
                    option.push({
                        value: lang === 'en' ? element.nameEn : element.nameTh,
                        id: element.statusId,
                    });
                });
                option?.map((element) => initial.push(element.id));
                // setInitialStatus(initial)
                setStatusType(option || []);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const deleteDataFlow = async (id) => {
        await DataFlowService.deleteDataFlow(id)
            .then((res) => {
                if (res?.data?.errorData) {
                    if (res?.data?.errorData?.code === 400) {
                        setOpenFail(true);
                        setMsg(res?.data?.errorData?.msg);
                    }
                } else {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully deleted data'),
                    });
                }
                searchDataFlowList(searchValue, currentPage);
            })
            .catch((err) => {
                setOpenFail(true);
                setMsg(t('common.FailedDeleteData'));
            });
    };

    const searchDataFlowList = async (payload, pageValue) => {
        try {
            const { data } = await DataFlowService.searchDataFlowList({
                departmentId: payload.departmentId ? payload.departmentId : '',
                businessProcessName: payload.businessProcessName
                    ? payload.businessProcessName
                    : '',
                purposeName: payload.purposeName ? payload.purposeName : '',
                reviewBy: payload.reviewBy ? payload.reviewBy : '',
                status: payload.status
                    ? payload.status.join(',')
                    : initialStatus.join(','),
                startDate: payload?.requestDate
                    ? moment(payload.requestDate[0]).toISOString()
                    : '',
                endDate: payload?.requestDate
                    ? moment(payload.requestDate[1]).toISOString()
                    : '',
                p: pageValue.page ? pageValue.page : 1,
                ps: pageValue.pageSize ? pageValue.pageSize : 10,
                s: payload?.sortBy ? payload?.sortBy[0] : 'modify_date',
                sd: payload?.sortBy ? payload?.sortBy[1] : 'DESC',
            });
            setLoading(false);
            setCardData(data?.resultData?.result || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        getDepartment();
        getStatus();
    }, [i18n.language]);

    useEffect(() => {
        if (loading) {
            searchDataFlowList(searchValue, currentPage);
        }
    }, [searchValue, currentPage.page, currentPage.pageSize]);

    useEffect(() => {
        const search = {
            p: 1,
            ps: 10,
            s: 10,
            total: 0,
        };
        if (loading) {
            searchDataFlowList(searchValue, search);
        }
    }, [searchValue]);

    const [loadingExport, setLoadingExport] = useState(false);

    const handelOk = async () => {
        try {
            setLoadingExport(true);
            const time = moment(new Date()).format('YYYY-MM-DD');
            const { data } = await DataFlowService.export();
            if (data) {
                const objectURL = URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = objectURL;
                link.download = `DataFlow_${time}.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                setLoadingExport(false);
                setOpenConfirm(false);
            }
        } catch (error) {
            setLoadingExport(false);
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to download'),
            });
        }
    };

    const { isAuditor } = usePermission();

    return (
        <Layout>
            <div className="title ">{t('dataFlow.Data Flow')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('Data Inventory')} /{' '}
                </span>
                <span> {t('dataFlow.Data Flow')}</span>
            </div>
            <div className="content_">
                <div>
                    <SearchBar
                        className="w-full"
                        formRef={form}
                        item={[
                            {
                                name: 'sortBy',
                                type: 'Select',
                                placeholder: t('Sort By'),
                            },
                            {
                                label: t('dataFlow.Department'),
                                placeholder: t('dataFlow.SelectDepartment'),
                                name: 'departmentId',
                                type: 'Select',
                                option: departmentList,
                            },
                            {
                                label: t('dataFlow.BusinessProcess'),
                                placeholder: t(
                                    'dataFlow.SearchBusinessProcess'
                                ),
                                name: 'businessProcessName',
                                type: 'Input',
                                option: [],
                            },
                            {
                                label: t('dataFlow.Purpose'),
                                placeholder: t('dataFlow.SearchPurpose'),
                                name: 'purposeName',
                                type: 'Input',
                                option: [],
                            },
                            {
                                label: t('Reviewer'),
                                placeholder: t('Search Reviewer'),
                                name: 'reviewBy',
                                type: 'Input',
                            },
                            {
                                label: t('Update Date'),
                                placeholder: [t('Start date'), t('End date')],
                                name: 'requestDate',
                                type: 'RangePicker',
                            },
                            {
                                label: t('Status'),
                                name: 'status',
                                type: 'CheckboxByKey',
                                option: statusType,
                                initialValue: initialStatus,
                            },
                        ]}
                        onClear={() => {
                            setLoading(true);
                            setSearchValue({
                                status: initialStatus,
                            });
                            setCurrentPage({
                                ...currentPage,
                                page: 1,
                            });
                        }}
                        onFinish={(e) => {
                            setLoading(true);
                            setSearchValue({
                                ...e,
                            });
                            setCurrentPage({
                                ...currentPage,
                                page: 1,
                            });
                        }}
                    />
                </div>
                <div className="w-full">
                    <div className="flex py-2 px-4">
                        <div className="flex-1">
                            <div className="text-xl font-medium">
                                {t('dataFlow.Data Flow List')}
                            </div>
                            <div className="text-xs font-normal text-gray-PHX mt-1">
                                {t('dataFlow.DataFlowSubtitle')}
                            </div>
                            <div className="text-xs font-semibold text-gray-PHX mt-4">
                                {t('TotalItems', {
                                    length: currentPage.total,
                                })}
                            </div>
                        </div>
                        <div className="flex space-x-2">
                            <Button
                                className="w-full px-10 border-purple-PHX text-purple-PHX"
                                size="large"
                                onClick={() => setOpenConfirm(true)}
                            >
                                {t('Export')}
                            </Button>
                            <Button
                                className="w-full px-10"
                                size="large"
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => setOpenModal(true)}
                                disabled={isAuditor}
                            >
                                {t('common.Add')}
                            </Button>
                        </div>
                    </div>
                    <div>
                        <ListCard
                            setLoading={setLoading}
                            setOpenDelete={setOpenDelete}
                            setBusinessProcess={setBusinessProcess}
                            dataSource={cardData}
                            onChangePage={setCurrentPage}
                            currentPage={currentPage}
                        />
                    </div>
                </div>
            </div>

            <ModalConfirm
                loading={loadingExport}
                title={t('Confirm Download')}
                text={t('Do you want to download this file')}
                open={openConfirm}
                handelOk={handelOk}
                handelClose={() => setOpenConfirm(false)}
            />
            <ModalDataFlow
                mode="addDataFlow"
                departmentList={departmentList}
                open={openModal}
                handelClose={() => {
                    setOpenModal(false);
                }}
            />
            <ModalFail
                text={msg}
                open={openFail}
                handelClose={() => setOpenFail(false)}
            />
            <ModalDelete
                open={openDelete}
                text={t('modalDataFlowDelete', {
                    name: businessProcess.businessProcessName,
                })}
                handelOk={() => {
                    deleteDataFlow(businessProcess.businessProcessId);
                    setOpenDelete(false);
                }}
                handelClose={() => setOpenDelete(false)}
            />
        </Layout>
    );
}
